'use client';

import { type ReactNode, useLayoutEffect } from 'react';

const SELECTOR = '[data-blog-hero-sync]';

export function BlogHeroLayout({ left, right }: { left: ReactNode; right: ReactNode }) {
  useLayoutEffect(() => {
    const sync = () => {
      const elements = document.querySelectorAll<HTMLElement>(SELECTOR);
      if (elements.length === 0) return;

      for (const el of elements) el.style.minHeight = '';

      if (window.innerWidth <= 640) return;

      const maxHeight = Math.max(...Array.from(elements).map((el) => el.scrollHeight));
      for (const el of elements) el.style.minHeight = `${maxHeight}px`;
    };

    sync();

    const observer = new ResizeObserver(sync);
    const elements = document.querySelectorAll(SELECTOR);
    for (const el of elements) observer.observe(el);
    window.addEventListener('resize', sync);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', sync);
    };
  }, []);

  return (
    <div className="mx-auto flex w-full max-w-none items-start justify-center gap-[92px] px-10 sm:flex-col sm:gap-6 sm:px-4 md:px-4 lg:flex-col lg:items-start lg:justify-start lg:gap-8">
      <div
        className="lg:!h-auto flex w-[516px] flex-shrink-0 flex-col justify-between gap-6 lg:w-full"
        data-blog-hero-sync
      >
        {left}
      </div>
      <div
        className="relative aspect-[4/3] min-w-0 flex-none overflow-hidden rounded-16 sm:aspect-[16/9] sm:w-full lg:w-full"
        data-blog-hero-sync
      >
        {right}
      </div>
    </div>
  );
}
